export default __webpack_public_path__ + "static/media/1997.493051a5.png";